import { types } from '../actions/expenses';

const initialState = {
  pending: false,
  pendingInfinityScroll: false,
  pendingDelete: false,
  error: '',
  data: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.GET_EXPENSES_PENDING:
      return { ...state, pending: true, error: '' };
    case types.GET_EXPENSES_REJECTED:
      return { ...state, pending: false, error: action.payload.message };
    case types.GET_EXPENSES_FULFILLED:
      return {
        ...state,
        pending: false,
        error: '',
        data: action.payload?.Data,
        pagination: action.payload?.Pagination
      };
    case types.CHANGE_EXPENSES_STATUS:
      return {
        ...state,
        data: state.data.map((item) => ({
          ...item,
          Status: {
            ...item.Status
          }
        }))
      };
    case types.GET_NEXT_EXPENSES_PENDING:
      return { ...state, pendingInfinityScroll: true, error: '' };
    case types.GET_NEXT_EXPENSES_REJECTED:
      return { ...state, pendingInfinityScroll: false, error: action.payload.message };
    case types.GET_NEXT_EXPENSES_FULFILLED:
      return {
        ...state,
        pendingInfinityScroll: false,
        error: '',
        data: [...state.data, ...action.payload.Data],
        pagination: action.payload?.Pagination
      };
    case types.DELETE_CLAIM_PENDING:
      return {
        ...state,
        pendingDelete: true
      };
    case types.DELETE_CLAIM_REJECTED:
      return {
        ...state,
        error: action.payload.message,
        pendingDelete: false
      };
    case types.DELETE_CLAIM_FULFILLED:
      return {
        ...state,
        pendingDelete: false,
        data: state.data ? state.data.filter((claim) => claim.Id !== action.payload) : state.data
      };
    default:
      return state;
  }
}
